import Controller from '../abstracts/Controller';
import 'scss-templates/t-cartV2.scss';

export default class CartV2Controller extends Controller {
  static get COMPONENTS() {
    return [
      'CartV2Component',
      'ShowPasswordComponent',
      'StoreLocatorComponent',
      'PromocodeV2Component',
      'RecommendationEngineComponent',
      'CompleteLookComponent',
      'EditorialCoverInfiniteComponent',
      'DynamicCarouselComponent',
    ];
  }
}
